import { Component, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    UnityLoadingIndicatorDisplay
} from '@Shared/Components/unity-loading-indicator/unity-loading-indicator.component';

@Component({
    standalone: false,
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {

    @Input() isAltLogin = false;
    @Input() selectTenants = false;
    @Input() selectedTenant: string;
    @Input() tenants: { key: string; name: string }[] = [];
    @Input() loading: boolean;
    @Input() errorMessage: string;

    public readonly UnityLoadingIndicatorDisplayEnum = UnityLoadingIndicatorDisplay;

    @Output() onLoginClick: EventEmitter<any> = new EventEmitter();
    @Output() onTenantSelect: EventEmitter<{ key: string; name: string }> = new EventEmitter();
    @Output() onChangeUser: EventEmitter<any> = new EventEmitter();
    @Output() onGoToPrimaryLogin: EventEmitter<any> = new EventEmitter();

    public changeForm(form_name: string) {
        this.loading = false;
    }

    public tenantSelect(tenant: any) {
        this.loading = true;
        const t = this.tenants?.find(x => x.key === tenant.key);
        this.onTenantSelect.emit({ key: tenant.key, name: t?.name });
    }

    public get auth0TenantName(): string {
        const envAuth = this.isAltLogin ? environment.altAuth : environment.auth;
        return this.stripHttpsPrefix(envAuth?.authUri)?.split(".")[0];
    }

    private stripHttpsPrefix(uri: string): string {
        return uri?.startsWith('https://') ? uri.substring(8) : uri;
    }
}
